import { useState, useCallback } from "react"
import {
  Box,
  Divider,
  SwipeableDrawer as MuiSwipeableDrawer,
  styled,
} from "@mui/material"
import { deepmerge } from "@mui/utils"
import { Global } from "@emotion/react"
import SimpleBar from "simplebar-react"

// TODO: add box-shadow to BleedWrapper
const BleedWrapper = styled(Box, {
  shouldForwardProp: (propName) => propName !== "drawerBleeding",
})(({ theme, drawerBleeding }) => ({
  position: "absolute",
  visibility: "visible",
  right: 0,
  left: 0,
  top: -drawerBleeding,
  display: "flex",
  flexDirection: "column",
  borderTopLeftRadius: theme.shape.borderRadius,
  borderTopRightRadius: theme.shape.borderRadius,
  background: theme.palette.background.paper,
}))

const Puller = styled(Box)(({ theme }) => ({
  width: 30,
  height: 4,
  backgroundColor: theme.palette.grey[400],
  borderRadius: 3,
  position: "absolute",
  top: 15,
  left: "calc(50% - 15px)",
}))

export const SwipeableDrawer = ({
  drawerBleeding,
  children,
  contentProps = {},
  globalProps = {},
  ...props
}) => {
  const [open, setOpen] = useState(false)
  const [BleedComponent, HiddenComponent] = children

  const {
    onTouchStart = (event) => {
      event.nativeEvent.defaultMuiPrevented = true
    },
  } = contentProps
  const { sx = {} } = globalProps

  const handleOpenDrawer = useCallback(() => {
    setOpen(true)
  }, [])

  const handleCloseDrawer = useCallback(() => {
    setOpen(false)
  }, [])

  return (
    <>
      <Global
        styles={deepmerge(
          {
            ".MuiDrawer-root > .MuiPaper-root": {
              height: drawerBleeding
                ? `calc(80% - ${drawerBleeding}px)`
                : "auto",
              overflow: "visible",
            },
          },
          sx
        )}
      />
      <MuiSwipeableDrawer
        anchor="bottom"
        open={open}
        onClose={handleCloseDrawer}
        onOpen={handleOpenDrawer}
        swipeAreaWidth={drawerBleeding}
        disableSwipeToOpen={false}
        hideBackdrop
        disableEnforceFocus
        ModalProps={{
          keepMounted: true,
        }}
        {...props}
      >
        <BleedWrapper
          onClick={handleCloseDrawer}
          drawerBleeding={drawerBleeding}
          style={{
            height: open
              ? `calc(100% + ${drawerBleeding}px)`
              : `${drawerBleeding}px`,
          }}
        >
          <Puller className="MuiSwipeableDrawer-puller" />
          {BleedComponent}
          <Divider
            className="SwipeableDrawer-divider"
            sx={{ borderBottom: "1px solid rgba(203, 203, 203, 0.5)" }}
          />
          <SimpleBar
            style={{
              height: "100%",
              overflow: "auto",
            }}
            onTouchStart={onTouchStart}
            //from https://github.com/mui/material-ui/issues/18884#issuecomment-1523981868
          >
            {HiddenComponent}
          </SimpleBar>
        </BleedWrapper>
      </MuiSwipeableDrawer>
    </>
  )
}

export default SwipeableDrawer
